import 'css-chunk:src/feature/checks/ChecksList.module.scss';export default {
  "filter_bar": "ChecksList_filter_bar",
  "filters": "ChecksList_filters",
  "actions": "ChecksList_actions",
  "table": "ChecksList_table",
  "edit_tip_btn": "ChecksList_edit_tip_btn",
  "reset_filter_btn": "ChecksList_reset_filter_btn",
  "table_cell_open": "ChecksList_table_cell_open",
  "table_cell_error": "ChecksList_table_cell_error",
  "table_cell_error_strike": "ChecksList_table_cell_error_strike",
  "table_cell_warn": "ChecksList_table_cell_warn",
  "table_cell_disable_look": "ChecksList_table_cell_disable_look",
  "corner_triangle": "ChecksList_corner_triangle",
  "table_label_col": "ChecksList_table_label_col"
};